import { createSelector } from '@reduxjs/toolkit';
import { ChatProviderType } from '../../../chat/models/ChatProviderType';
import { selectChatSessionIds } from './selectChatSessionIds';
import { selectChatSessionsById } from './selectChatSessionsById';

export const selectActiveChatSessionCount = createSelector(
    [selectChatSessionIds, selectChatSessionsById],
    (sessionIds, sessionsById): number =>
        sessionIds.reduce((count, sessionId) => {
            const session = sessionsById[sessionId];

            if (!session || session.providerType === ChatProviderType.Assistants) {
                return count;
            }

            return count + 1;
        }, 0),
);
